import request from '@/utils/request'

export const versionApi = {
  /**
   * Get latest published version info
   */
  getLatestVersion() {
    return request({
      url: '/api/website/version',
      method: 'get'
    })
  }
}
